<div class="inbox-view">
  <app-inbox-sidebar></app-inbox-sidebar>
  <app-conversation-list></app-conversation-list>
  <app-conversation-detail></app-conversation-detail>
  <app-compose-minimized-bar></app-compose-minimized-bar>
</div>
